module.exports = __webpack_public_path__ + "img/room-carousel-6.eff170cd.jpg";